export const p100pro_base = [
  ['4D成像雷达', '电子件'],
  ['4G天线', '电子件'],
  ['UPS备用电池', '电子件'],
  ['2.4GHz WiFi天线', '电子件'],
  ['电池信号Y线', '电子件'],
  ['电调', '电子件'],
  ['动力电机', '电子件'],
  ['仿地雷达', '电子件'],
  ['飞控', '电子件'],
  ['负载线', '电子件'],
  ['5.8GHz WiFi天线', '电子件'],
  ['绞龙电机减速组', '电子件'],
  ['绞龙电机线组件', '电子件'],
  ['料箱药箱传感器', '电子件'],
  ['喷洒线', '电子件'],
  ['喷头', '电子件'],
  ['前视PSL摄像头', '电子件'],
  ['蠕动泵电机减速组-11L', '电子件'],
  ['睿播集线板', '电子件'],
  ['睿喷集线板', '电子件'],
  ['睿图模块', '电子件'],
  ['甩盘电机', '电子件'],
  ['甩盘电机线', '电子件'],
  ['下视PSL摄像头', '电子件'],
  ['右RTK天线', '电子件'],
  ['中心舱集线板', '电子件'],
  ['左RTK天线', '电子件'],
]
export const p100pro_advance = [
  ['4D成像雷达', '电子件'],
  ['4G天线', '电子件'],
  ['UPS备用电池', '电子件'],
  ['2.4GHz WiFi天线', '电子件'],
  ['电池信号Y线', '电子件'],
  ['电调', '电子件'],
  ['动力电机', '电子件'],
  ['仿地雷达', '电子件'],
  ['飞控', '电子件'],
  ['负载线', '电子件'],
  ['5.8GHz WiFi天线', '电子件'],
  ['绞龙电机减速组', '电子件'],
  ['绞龙电机线组件', '电子件'],
  ['料箱药箱传感器', '电子件'],
  ['喷洒线', '电子件'],
  ['喷头', '电子件'],
  ['前视PSL摄像头', '电子件'],
  ['蠕动泵电机减速组-11L', '电子件'],
  ['睿播集线板', '电子件'],
  ['睿喷集线板', '电子件'],
  ['睿图模块', '电子件'],
  ['甩盘电机', '电子件'],
  ['甩盘电机线', '电子件'],
  ['下视PSL摄像头', '电子件'],
  ['右RTK天线', '电子件'],
  ['中心舱集线板', '电子件'],
  ['左RTK天线', '电子件'],
  ['4G天线压盖', '结构件'],
  ['把手盖', '结构件'],
  ['绑带固定架', '结构件'],
  ['绑带固定件', '结构件'],
  ['抱箍', '结构件'],
  ['边梁', '结构件'],
  ['搭扣底座', '结构件'],
  ['电池导轨胶垫', '结构件'],
  ['电池导轨组件', '结构件'],
  ['电池尾插上壳', '结构件'],
  ['电池尾插下壳', '结构件'],
  ['电池尾框', '结构件'],
  ['电调端子保护盖', '结构件'],
  ['电调端子固定座', '结构件'],
  ['电调端子长支撑管', '结构件'],
  ['电机端机臂', '结构件'],
  ['电机端绞龙同步齿轮', '结构件'],
  ['电调端子长支撑管', '结构件'],
  ['动力电机减震固定座', '结构件'],
  ['仿地雷达防尘盖', '结构件'],
  ['负载框', '结构件'],
  ['负载框&脚架固定件', '结构件'],
  ['负载框胶塞', '结构件'],
  ['负载连接线接头卡件', '结构件'],
  ['感应模块固定件', '结构件'],
  ['横梁', '结构件'],
  ['汇流板', '结构件'],
  ['汇流板O型圈', '结构件'],
  ['汇流板螺钉胶塞', '结构件'],
  ['机臂防呆弹片', '结构件'],
  ['机臂防撞胶', '结构件'],
  ['机臂防撞胶压件', '结构件'],
  ['机臂管压件', '结构件'],
  ['机臂管压件橡胶', '结构件'],
  ['机臂机身端旋转件', '结构件'],
  ['机臂软胶支撑', '结构件'],
  ['机臂折叠固定绑带', '结构件'],
  ['机臂主轴螺栓组件', '结构件'],
  ['机身把手', '结构件'],
  ['机身部分底部挡板', '结构件'],
  ['机身端机臂', '结构件'],
  ['机身端机臂防摩胶', '结构件'],
  ['机身载荷对接件', '结构件'],
  ['机身载荷对接件软胶', '结构件'],
  ['机头红色支撑杆', '结构件'],
  ['机头卡线件', '结构件'],
  ['机头罩', '结构件'],
  ['机头支撑杆右固定件', '结构件'],
  ['机头支撑杆左固定件', '结构件'],
  ['绞龙电机减速箱硅胶O型圈', '结构件'],
  ['绞龙电机散热硅胶', '结构件'],
  ['绞龙电机线卡线EVA棉', '结构件'],
  ['绞龙电机罩', '结构件'],
  ['绞龙端绞龙同步齿轮', '结构件'],
  ['绞龙对接轴', '结构件'],
  ['绞龙骨架油封', '结构件'],
  ['绞龙管抱紧卡扣', '结构件'],
  ['绞龙卡扣转轴', '结构件'],
  ['绞龙同步齿轮电机端中轴O型硅胶圈', '结构件'],
  ['绞龙中轴出料口O型硅胶圈', '结构件'],
  ['快拆把手转轴', '结构件'],
  ['快拆搭扣', '结构件'],
  ['馈线卡线架', '结构件'],
  ['雷达信号线接头卡扣件', '结构件'],
  ['料箱脚架卡管内钣金件', '结构件'],
  ['料箱脚架卡管外钣金件', '结构件'],
  ['料箱脚架橡胶防护片', '结构件'],
  ['喷杆顶盖', '结构件'],
  ['喷杆内部嵌件', '结构件'],
  ['喷杆折叠固定件', '结构件'],
  ['蠕动泵A泵头-11L', '结构件'],
  ['蠕动泵B泵头-11L', '结构件'],
  ['睿播同步齿轮盖', '结构件'],
  ['睿图塑胶减震结构', '结构件'],
  ['睿图塑胶减震结构支架', '结构件'],
  ['收纳线束硅胶件', '结构件'],
  ['甩盘&绞龙电机卡线扣', '结构件'],
  ['水泵对接件药箱固定件', '结构件'],
  ['水管转接件', '结构件'],
  ['天线口盖板', '结构件'],
  ['天线遮盖件', '结构件'],
  ['天线支架', '结构件'],
  ['同步齿轮轴锁紧件', '结构件'],
  ['头罩固定管', '结构件'],
  ['头罩后固定管卡件', '结构件'],
  ['头罩卡线件', '结构件'],
  ['头罩框架', '结构件'],
  ['头罩前固定管卡件', '结构件'],
  ['尾框横梁', '结构件'],
  ['下视PSL摄像头固定件', '结构件'],
  ['药箱脚架卡管外钣金件', '结构件'],
  ['右喷杆固定件', '结构件'],
  ['中心舱盖', '结构件'],
  ['中心舱线材固定件', '结构件'],
  ['主体框架防摩擦棉', '结构件'],
  ['左喷杆固定件', '结构件'],
]
